import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

const resources = {
  ro: {
    common: {
      brand: "Demo",
      nav: { home: "Acasă", gallery: "Galerie" },
      switch: "EN",

      hero: {
        title: "Site de prezentare — Demo",
        subtitle:
          "Acesta este un text de umplutură pentru demonstrație. Înlocuiește-l cu mesajul tău real.",
      },

      services: {
        title: "Servicii (Demo)",
        items: {
          repair: "Element 1 de serviciu",
          install: "Element 2 de serviciu",
          replace: "Element 3 de serviciu",
          sell: "Element 4 de serviciu",
        },
      },

      contact: {
        title: "Adresă & Contact (Demo)",
        hours: {
          label: "Program",
          value: "L–V 9:00 – 17:00 (exemplu)",
        },
        address: {
          label: "Adresă",
          street: "Str. Exemplu 123, Oraș, Țară",
          zip: "000000",
          mapsCta: "Deschide în Google Maps",
        },
        phone: {
          label: "Telefon",
          note: "Apelați pentru întrebări și programări (text de demo).",
        },
      },

      reviews: {
        title: "Review-uri Google pentru {{place}}",
        defaultName: "compania noastră",
        subtitle:
          "Aici pot apărea câteva recenzii reprezentative. Acesta este un text de demonstrație.",
        count: "{{count}} review-uri pe Google",
        loading: "Se încarcă review-urile…",
        error: "Nu am putut încărca review-urile (demo).",
        none: "Momentan nu există review-uri (demo).",
        anon: "Utilizator Google",
        ctaWrite: "Lasă un review",
        ctaSeeAll: "Vezi toate pe Google",
      },

      why: {
        title: "De ce să alegi Demo?",
        bullets: [
          "Punct de listă de exemplu pentru a umple spațiul.",
          "Alt punct de listă generic pentru prezentare.",
          "Încă un punct cu text scurt de demonstrație.",
        ],
      },

      cta: { primary: "Solicită o ofertă (Demo)" },

      benefits: {
        fast: {
          title: "Rapid și simplu",
          desc: "Programări flexibile și timp de răspuns scurt (demo).",
        },
        cert: {
          title: "Calitate constantă",
          desc: "Procese clare și rezultate predictibile (text de demo).",
        },
      },

      process: {
        title: "Cum lucrăm (Demo)",
        subtitle:
          "Flux simplificat pentru a demonstra secțiunea de proces.",
        steps: [
          {
            title: "Pasul 1",
            desc: "Descriere scurtă de umplutură pentru pasul unu.",
          },
          {
            title: "Pasul 2",
            desc: "Text generic pentru acest pas din demo.",
          },
          {
            title: "Pasul 3",
            desc: "Mai mult text de demonstrație, concis și clar.",
          },
          {
            title: "Pasul 4",
            desc: "Concluzie/închidere proces (exemplu).",
          },
        ],
      },

      stats: {
        warranty: { label: "Garanție", value: "—", desc: "demo" },
        area: { label: "Acoperire", value: "—", desc: "demo" },
      },

      gallery: {
        title: "Galerie (Demo)",
        cta: "Aceasta este o descriere de umplutură pentru pagina de galerie. Înlocuiește cu textul real când conținutul este gata.",
        empty: "Galeria va fi populată cu imagini (demo).",
        view: "Vezi galeria",
        backHome: "Înapoi la Acasă",
      },

      ctaBar: {
        title: "Bară de apel la acțiune (Demo)",
        subtitle: "Text scurt și descriptiv pentru demonstrație.",
      },

      footer: { location: "Locație — Demo" },

      consent: {
        message: {
          pre: "Folosim cookie-uri pentru funcționalitate și, cu acordul tău, pentru",
          analytics: "analitică",
          ads: "publicitate",
          and: "și",
        },
        actions: {
          customize: "Personalizează",
          reject: "Respinge",
          accept: "Acceptă",
          back: "Înapoi",
          save: "Salvează",
        },
        categories: {
          functional: "Funcțional & securitate (obligatoriu)",
          analytics: "Analitică",
          ads: "Publicitate",
        },
        reset: {
          prefix: "Poți reseta oricând:",
          button: "șterge preferințele",
          suffix: "",
        },
      },
    },
  },

  en: {
    common: {
      brand: "Demo",
      nav: { home: "Home", gallery: "Gallery" },
      switch: "RO",

      hero: {
        title: "Presentation Website — Demo",
        subtitle:
          "Placeholder copy to showcase layout and components. Replace with your real message.",
      },

      services: {
        title: "Services (Demo)",
        items: {
          repair: "Service Item One",
          install: "Service Item Two",
          replace: "Service Item Three",
          sell: "Service Item Four",
        },
      },

      contact: {
        title: "Address & Contact (Demo)",
        hours: {
          label: "Opening hours",
          value: "Mon–Fri 9:00 – 17:00 (sample)",
        },
        address: {
          label: "Address",
          street: "123 Example Street, City, Country",
          zip: "000000",
          mapsCta: "Open in Google Maps",
        },
        phone: {
          label: "Phone",
          note: "Call for questions and bookings (demo copy).",
        },
      },

      reviews: {
        title: "Google Reviews for {{place}}",
        defaultName: "our business",
        subtitle:
          "A few representative reviews could appear here. This is demo text.",
        count: "{{count}} reviews on Google",
        loading: "Loading reviews…",
        error: "Couldn't load reviews (demo).",
        none: "No reviews yet (demo).",
        anon: "Google user",
        ctaWrite: "Leave a review",
        ctaSeeAll: "See all on Google",
      },

      why: {
        title: "Why choose Demo?",
        bullets: [
          "Example bullet to occupy space.",
          "Another generic bullet for the presentation.",
          "One more short bullet of demo text.",
        ],
      },

      cta: { primary: "Request a quote (Demo)" },

      benefits: {
        fast: {
          title: "Quick & simple",
          desc: "Flexible scheduling and short response times (demo).",
        },
        cert: {
          title: "Consistent quality",
          desc: "Clear processes and predictable results (demo text).",
        },
      },

      process: {
        title: "How we work (Demo)",
        subtitle: "A simplified flow to demonstrate this section.",
        steps: [
          {
            title: "Step 1",
            desc: "Short placeholder about what happens here.",
          },
          {
            title: "Step 2",
            desc: "Generic copy for the second step in the demo.",
          },
          {
            title: "Step 3",
            desc: "Additional concise demo text for clarity.",
          },
          {
            title: "Step 4",
            desc: "Wrap-up/hand-off description (sample).",
          },
        ],
      },

      stats: {
        warranty: { label: "Warranty", value: "—", desc: "demo" },
        area: { label: "Coverage", value: "—", desc: "demo" },
      },

      gallery: {
        title: "Gallery (Demo)",
        cta: "This is placeholder copy for the gallery page. Replace with real text when assets are ready.",
        empty: "The gallery will be populated with images (demo).",
        view: "View gallery",
        backHome: "Back to Home",
      },

      ctaBar: {
        title: "Call-to-Action Bar (Demo)",
        subtitle: "Short, descriptive helper text for the demo.",
      },

      footer: { location: "Location — Demo" },

      consent: {
        message: {
          pre: "We use cookies for functionality and, with your consent, for",
          analytics: "analytics",
          ads: "advertising",
          and: "and",
        },
        actions: {
          customize: "Customize",
          reject: "Reject",
          accept: "Accept",
          back: "Back",
          save: "Save",
        },
        categories: {
          functional: "Functional & security (required)",
          analytics: "Analytics",
          ads: "Advertising",
        },
        reset: {
          prefix: "You can reset anytime:",
          button: "clear preferences",
          suffix: "",
        },
      },
    },
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "ro",
    defaultNS: "common",
    interpolation: { escapeValue: false },
    detection: {
      order: ["querystring", "localStorage"],
      caches: ["localStorage"],
    },
  });

export default i18n;
